import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../../domain/amplitude'
import { ADDRESS_SCREEN } from '../Address/types'

export type PersonalInFormationFormValues = {
  dob: Date | null
  ssn: string
  annualIncome: number
}

export type ComponentState = PersonalInFormationFormValues & {
  showSnn: boolean
  validationErrors: Record<string, string | void>
}

export type PersonalInFormationFormProps = {
  formData: PersonalInFormationFormValues
  setFormData: (data: PersonalInFormationFormValues) => void
}

export const PERSONAL_SCREEN = 'application_info2'

export const PersonalScreenOpened: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  from_screen: ADDRESS_SCREEN,
  screen: PERSONAL_SCREEN,
  heading: 'We keep your personal info safe and secure'
}

export const PersonalScreenNextButton: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: PERSONAL_SCREEN
}
